import { type MutationError, trpc } from '@/shared/api';

interface UseHideProductOptions {
  readonly onSuccess?: () => void;
}

interface UseHideProductResult {
  readonly hide: (id: string) => void;
  readonly isPending: boolean;
  readonly error: MutationError | null;
  /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
  readonly reset: () => void;
}

/** 공개 상품 숨김 — DRAFT 로의 역전이는 없다. */
export const useHideProduct = ({ onSuccess }: UseHideProductOptions = {}): UseHideProductResult => {
  const mutation = trpc.productManagement.products.hide.useMutation({ onSuccess });

  return {
    hide: (id) => mutation.mutate({ id }),
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
};
